var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "b-card",
        { staticClass: "management-tabs", attrs: { "no-body": "" } },
        [
          _c(
            "b-tabs",
            { attrs: { pills: "", card: "", vertical: "" } },
            [
              _vm.$store.state.authUser.flag == "Admin"
                ? _c(
                    "b-tab",
                    { attrs: { title: "Create Module Session", active: "" } },
                    [
                      _c(
                        "b-card",
                        { attrs: { "no-body": "" } },
                        [
                          _c(
                            "b-tabs",
                            {
                              attrs: { pills: "", card: "" },
                              model: {
                                value: _vm.createMsTabIdx,
                                callback: function($$v) {
                                  _vm.createMsTabIdx = $$v
                                },
                                expression: "createMsTabIdx"
                              }
                            },
                            [
                              _c(
                                "b-tab",
                                {
                                  attrs: {
                                    title: "Bulky Create",
                                    "title-link-class": _vm.msLinkClass(0),
                                    active: ""
                                  }
                                },
                                [
                                  _c("BulkyCreateNewModuleSession", {
                                    on: {
                                      bulkyModuleSessionCreate:
                                        _vm.bulkyModuleSessionCreate
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "b-tab",
                                {
                                  attrs: {
                                    title: "Individual Create",
                                    "title-link-class": _vm.msLinkClass(1)
                                  }
                                },
                                [
                                  _c("CreateNewModuleSessionForm", {
                                    on: {
                                      createNewModuleSession:
                                        _vm.createNewModuleSession
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "b-tab",
                { attrs: { title: "Edit User Information" } },
                [_c("EditUserPanel")],
                1
              ),
              _vm.$store.state.authUser.flag == "Admin"
                ? _c(
                    "b-tab",
                    { attrs: { title: "Approve User Edited" } },
                    [_c("PendingApproveEditUserInfo")],
                    1
                  )
                : _vm._e(),
              _vm.$store.state.authUser.flag == "Admin"
                ? _c(
                    "b-tab",
                    { attrs: { title: "Add New Module" } },
                    [
                      _c("AddNewModule", {
                        on: {
                          addNewModule: _vm.addNewModule,
                          removeModuleName: _vm.removeModuleName
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.$store.state.authUser.flag == "Admin"
                ? _c(
                    "b-tab",
                    { attrs: { title: "Add New Language" } },
                    [
                      _c("AddNewLanguage", {
                        on: {
                          addNewLanguage: _vm.addNewLanguage,
                          removeLanguages: _vm.removeLanguages
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _c("p", [_vm._v("this is MANAGEMENT page")])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7aa2ce4c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7aa2ce4c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/dashboard/management/index.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-7aa2ce4c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/dashboard/management/index.vue
// module chunks = 0